import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../../utils/Icon";
import Button from "../../../../../Core/Button/Button";
import Pagination from "../../../../../Components/Pagination";
import { handleDownloadCSV } from "../../../../../utils/CsvDownload";
import { usePostItemScanApiMutation } from "../../../../../store/api/salesinvoiceAuricApi";
import EditItemModal from "../General_Details/EditItemModal";
import ConfigureColumns from "../Components/ConfigureColumns";

const PaymentTable = ({ po_status, setRows, rows, totalamount,error,allocate_advances_automatically }) => {

  const createNewRow = () => ({
          reference_name:'',
          remarks: 0,
          advance_amount: "",
          allocated_amount: "",
          difference_posting_date: "",
        });
  
  const initialColumns = [
  { key: "action", name: "Action", width: "6%", selected: true },
  { key: "slno", name: "Sl.No", width: "6%", selected: true },
  { key: "name", name: "Reference Name", width: "12%", selected: true },
  { key: "remarks", name: "Remarks", width: "20%", selected: true },
  { key: "unallocated_amount", name: "Advance Amount", width: "10%", selected: true },
  { key: "allocated_amount", name: "Allocated Amount", width: "10%", selected: true },
  { key: "difference_posting_date", name: "Difference Posting Date", width: "10%", selected: true },
  { key: "setting", name: "Setting", width: "6%", selected: true },
  ];

const [columns, setColumns] = useState(initialColumns);
const [showColumnConfig, setShowColumnConfig] = useState(false);
const visibleColumns = columns.filter(col => col.selected);

const handleSaveColumns = (updatedColumns) => {
  setColumns(updatedColumns);
  setShowColumnConfig(false);
};

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const [showEditModal, setShowEditModal] = useState(false);
  const [scanItemApi] = usePostItemScanApiMutation();


  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIndices])]);
    } else {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => prev.filter((i) => !pageRowIndices.includes(i)));
    }
  };

  

  const [popdata, setpopdata] = useState();

  const openEditModal = (row, index,index2) => {
    setShowEditModal(true);
    setpopdata({ row, index,index2 ,setRows,rows});
  };


  const updateRow = (index, field, value) => {
    let updatedRow;
    if (field === "item") {
      updatedRow = {
        ...rows[index],
        item: value,
        item_code: value.item_code,
        rate: value.buying_price || rows[index].rate,
      };
    } else {
      updatedRow = { ...rows[index], [field]: value };
    }

    const quantity = parseFloat(updatedRow.quantity) || 0;
    const rate = parseFloat(updatedRow.rate) || 0;
    updatedRow.amount = (quantity * rate).toFixed(2);

    const updatedRows = [...rows];
    updatedRows[index] = updatedRow;
    setRows(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows([]);
    setRows(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

//   useEffect(() => {
//   if (rows.length > 0 && totalamount.grandtotal_with_payment_type) {
//     let remaining = parseFloat(totalamount.grandtotal_with_payment_type);
//     const updatedRows = rows.map((row) => {
//       let allocated = 0;
//       const unallocated = parseFloat(row.unallocated_amount) || 0;

//       if (remaining > 0) {
//         if (unallocated <= remaining) {
//           allocated = unallocated;
//           remaining -= unallocated;
//         } else {
//           allocated = remaining;
//           remaining = 0;
//         }
//       }
//       return { ...row, allocated_amount: allocated.toFixed(2) };
//     });
//     setRows(updatedRows);
//   }
// }, [rows.length, totalamount.grandtotal_with_payment_type, allocate_advances_automatically]);



  return (
    <div className="">
      <div className="py-2  d-flex justify-content-between">
        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Advances</p>
      </div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {visibleColumns.map((col, index) => (
      <th
        key={col.key}
        style={{
          width: col.width,
          textAlign: "center",
          position: "relative"
        }}
      >
        {col.key === "setting" ? (
          <div onClick={() => setShowColumnConfig(true)} style={{ cursor: "pointer" }}>
            <GetIcon iconName="IoSettingsOutline" size={14} />
          </div>
        ) : (
          col.name
        )}
      </th>
    ))}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex} style={{ height: '30px' }}>
                <td className="p-0" style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                      </span>
                    )}
                  </p>
                </td>
                <td className="p-0" style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  lineHeight: '29px'
                }}>
                  {globalIndex + 1}
                </td>

                
                {/* Item Name */}
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.name || ""} />
                </td>

                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.remarks || ""} />
                </td>
      
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.unallocated_amount || ""} />
                </td>
     
                <td className="p-0">
                  <input
                    type="number"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    value={row.allocated_amount}
                    readOnly={allocate_advances_automatically}
                   onChange={(e) => {
  const newVal = parseFloat(e.target.value) || '';
  const totalAllocated = rows.reduce(
    (sum, r, idx) => sum + (idx === index ? newVal : parseFloat(r.allocated_amount) || 0),
    0
  );

  if (totalAllocated > totalamount.grandtotal_with_payment_type) {
    error.seterrorMessage(`Total allocated amount cannot exceed total order amount!`);
    error.seterrorType("Error");
    error.setisErrorVisible(true);
    return;
  }

  const updatedRows = rows.map((row, idx) =>
    idx === index ? { ...row, allocated_amount: newVal } : row
  );
  setRows(updatedRows);
}}


  />


                </td>


                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.difference_posting_date || ""} />
                </td>
               

                <td className="p-0" >
                  <span
                    onClick={() => openEditModal(row, globalIndex, index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <GetIcon iconName="MdOutlineEdit" size={15} />
                  </span>
                </td>
         
      
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status == '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && po_status == '' && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ backgroundColor: '#F6D593', padding: '1px', display: 'flex' }}
            >
              Add Row
            </Button>
          )}
           <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
            onClick={() => {
              handleDownloadCSV([
                  "S.No",
                  "Item Design (Items)",
                  "Item Name (Items)",
                  "Category",
                  "Sub Category",
                  "Diamond Weight",
                  "Stone Weight",
                  "Pure Gold",
                  "Quantity (Items)",
                  "Rate (Items)",
                  "UOM (Items)",
                "Amount"]
                , rows,
              "purchase_order")
            }}
          >
            Download
          </Button>       
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#823455' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>

      </div>

        <ConfigureColumns
  show={showColumnConfig}
  onClose={() => setShowColumnConfig(false)}
  onSave={handleSaveColumns}
  initialFields={columns}
/>


         {
            showEditModal &&
            <EditItemModal
              show={showEditModal}
              onClose={() => setShowEditModal(false)}
              itemDataReal={popdata}
              updateRow={updateRow}
            />
          }
    </div>
  );
};

export default PaymentTable;